import { EMPTY_STATE_IMAGES } from '@sketch-note/design-system/src/shared/constants';
import React from 'react';

export interface EmptyNotificationProps {
  url?: string;
}

export const EmptyNotification = ({ url }: EmptyNotificationProps): JSX.Element => {
  return (
    <div className="py-20">
      <img
        src={EMPTY_STATE_IMAGES.notifications}
        width="340px"
        height="164px"
        className="mb-8 ml-20 mr-20"
        alt=""
      />
      <p className="font-medium text-center">Seems kinda empty in here!</p>
      <p className="text-sm text-center font-light text-gray-700 ml-20 mr-20">
        Any new notification about this workspace will show up here
      </p>
    </div>
  );
};
